export default "__VITE_PUBLIC_ASSET__7b136f97__"